export default __webpack_public_path__ + "static/media/market_place_2.4cd03299.webp";